<div>
  <menu-tabs [data]="menuTabs"/>
  <breadcrumb *ngIf="showBreadcrumb"/>
  <ng-content select="[main-content]"></ng-content>
</div>
